import type { IBusinessLocation } from "@/interfaces/api/business-location.interface.ts"
import { Location } from "@/models/location.model.ts"
import { ModelFactory } from "@/factories/model-factory.ts"
import { BaseModel } from "@/models/base.model.ts"

export class BusinessLocation extends BaseModel implements IBusinessLocation {
  public static className = "BusinessLocation"
  public static verboseName = "Bedrijfslocatie"

  registeredBusinessEntity: string
  location: Location

  isMain: boolean

  constructor(businessLocation: IBusinessLocation, managed = false) {
    super(businessLocation)

    this.registeredBusinessEntity = businessLocation.registeredBusinessEntity
    this.location = ModelFactory.childModel(Location, businessLocation.location, managed)

    this.isMain = businessLocation.isMain
  }
}
